/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useRef, useState } from "react";
import { useFetchOrderSummaryLMFM } from "../../../apis/dashboardApis";
import { useSelector } from "react-redux";

export default function OrderSummary({
  summaryType,
  startDate,
  endDate,
}: {
  summaryType?: string;
  startDate?: string;
  endDate?: string;
}) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const { data } = useFetchOrderSummaryLMFM({
    type: summaryType as any,
    startDate,
    endDate,
  });

  type MetricItem = {
    icon: string;
    label: string;
    lm: number;
    fm: number;
    total: number;
  };

  const split = (v?: { lm: number; fm: number; total: number }) => ({
    lm: v?.lm ?? 0,
    fm: v?.fm ?? 0,
    total: v?.total ?? 0,
  });

  const metrics: MetricItem[] = [
    {
      icon: "./img/dashboard-icons/all-orders.svg",
      label: "All Orders",
      ...split(data?.total),
    },
    {
      icon: "./img/dashboard-icons/new-orders.svg",
      label: "New Orders",
      ...split(data?.newOrder),
    },
    {
      icon: "./img/dashboard-icons/pickups.svg",
      label: "Collected",
      ...split(data?.pickupCollected),
    },
    {
      icon: "./img/dashboard-icons/inbounds.svg",
      label: "RIW",
      ...split(data?.receiveInWarehouse),
    },
    {
      icon: "./img/dashboard-icons/picking.svg",
      label: "Picking",
      ...split(data?.damage),
      // Not created it's api
    },
    {
      icon: "./img/dashboard-icons/picking.svg",
      label: "Packing",
      ...split(data?.damage),
      // Not created it's api
    },
    {
      icon: "./img/dashboard-icons/stock.png",
      label: "Shelve",
      ...split(data?.shelve),
    },
    {
      icon: "./img/dashboard-icons/ready-for-delivery.svg",
      label: "RFD",
      ...split(data?.readyForPickup),
    },
    {
      icon: "./img/dashboard-icons/out-for-delivery.svg",
      label: "OFD",
      ...split(data?.outForDelivery),
    },
    {
      icon: "./img/dashboard-icons/delivered.svg",
      label: "Delivered",
      ...split(data?.delivered),
    },
    {
      icon: "./img/dashboard-icons/not-delivered.svg",
      label: "N D",
      ...split(data?.notDelivered),
    },
    {
      icon: "./img/dashboard-icons/return-orders.svg",
      label: "Return",
      ...split(data?.returned),
    },
    {
      icon: "./img/dashboard-icons/missing.svg",
      label: "Missing",
      ...split(data?.lost),
    },
    {
      icon: "./img/dashboard-icons/damage.svg",
      label: "Damage",
      ...split(data?.damage),
    },
    {
      icon: "./img/dashboard-icons/cod-orders.svg",
      label: "COD",
      ...split(data?.cod),
    },
    {
      icon: "./img/dashboard-icons/cc-order.svg",
      label: "CC",
      ...split(data?.cc),
    },
  ];

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const profile = useSelector((state: any) => state.auth.profile);

  const clientType =
    "clientType" in (profile ?? {}) ? profile.clientType : undefined;
  const showLM = clientType === "LM" || clientType === "BOTH" || !clientType;

  const showFM = clientType === "FM" || clientType === "BOTH" || !clientType;

  return (
    <div className="space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <h2 className="text-xl font-semibold text-[#1E1E1E]">
            Order Summary
          </h2>

          <p className="text-sm text-[#8A8A8A] mt-1">
            Real-time overview of all order statuses
          </p>
        </div>

        {/* Top Small Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <div className="bg-[#F6F1FF] rounded-2xl px-5 py-4 min-w-[160px] flex items-center gap-2">
            <div className="w-12 h-12 rounded-full flex items-center justify-center bg-white">
              <img
                src="./img/dashboard-icons/all-orders.svg"
                alt=""
                className="w-6 h-6"
              />
            </div>
            <div>
              <p className="text-sm text-[#6B7280]">Total Orders</p>
              <h3 className="text-lg font-bold text-[#1F2937]">
                {data?.total?.total ?? 0}
              </h3>
            </div>
          </div>

          <div className="bg-[#EDFDF3] rounded-2xl px-5 py-4 min-w-[160px] flex items-center gap-2">
            <div className="w-12 h-12 rounded-full flex items-center justify-center bg-white">
              <img
                src="./img/dashboard-icons/delivered.svg"
                alt=""
                className="w-6 h-6"
              />
            </div>
            <div>
              <p className="text-sm text-[#6B7280]">Delivered</p>
              <h3 className="text-lg font-bold text-[#1F2937]">
                {data?.delivered?.total ?? 0}
              </h3>
            </div>
          </div>

          <div className="bg-[#FFF7EA] rounded-2xl px-5 py-4 min-w-[160px] flex items-center gap-2">
            <div className="w-12 h-12 rounded-full flex items-center justify-center bg-white">
              <img
                src="./img/dashboard-icons/pickups.svg"
                alt=""
                className="w-6 h-6"
              />
            </div>
            <div>
              <p className="text-sm text-[#6B7280]">Collected</p>
              <h3 className="text-lg font-bold text-[#1F2937]">
                {data?.pickupCollected?.total ?? 0}
              </h3>
            </div>
          </div>

          <div className="bg-[#EEF4FF] rounded-2xl px-5 py-4 min-w-[160px] flex items-center gap-2">
            <div className="w-12 h-12 rounded-full flex items-center justify-center bg-white">
              <img
                src="./img/dashboard-icons/inbounds.svg"
                alt=""
                className="w-6 h-6"
              />
            </div>
            <div>
              <p className="text-sm text-[#6B7280]">In Progress</p>
              <h3 className="text-lg font-bold text-[#1F2937]">
                {data?.newOrder?.total ?? 0}
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-5">
        {metrics.map((metric, idx) => {
          const lmPercent =
            metric.total > 0
              ? Math.round((metric.lm / metric.total) * 100)
              : 50;

          const colors = [
            "#7C3AED",
            "#F97316",
            "#EAB308",
            "#06B6D4",
            "#3B82F6",
            "#4F46E5",
            "#8B5CF6",
            "#0F766E",
            "#60A5FA",
            "#22C55E",
            "#A855F7",
            "#3B82F6",
            "#F43F5E",
            "#F97316",
            "#22C55E",
            "#06B6D4",
          ];

          return (
            <div
              key={idx}
              className="bg-white rounded-[24px] border border-[#ECECEC] p-5 shadow-sm hover:shadow-md transition-all duration-300"
            >
              {/* Top */}
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-3">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center"
                    style={{
                      backgroundColor: `${colors[idx]}15`,
                    }}
                  >
                    <img
                      src={metric.icon}
                      alt={metric.label}
                      className="w-6 h-6"
                    />
                  </div>

                  <div>
                    <h3 className="text-sm font-semibold text-[#1F2937]">
                      {metric.label}
                    </h3>
                  </div>
                </div>

                <span className="text-lg font-bold text-[#1F2937]">
                  {metric.total}
                </span>
              </div>

              {/* Progress */}
              <div className="w-full h-[7px] rounded-full bg-[#F1F1F1] overflow-hidden mb-5">
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${lmPercent}%`,
                    background: colors[idx],
                  }}
                />
              </div>

              {/* Bottom */}
              <div className="flex items-center justify-center gap-3 text-sm font-medium text-[#4B5563]">
                <span>LM {metric.lm}</span>

                <div className="w-[1px] h-4 bg-[#D1D5DB]" />

                <span>FM {metric.fm}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  // return (
  //   // <div className="rounded-3xl bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] p-6 grid grid-cols-12 gap-6 items-start">
  //   //   <div className="col-span-12 flex justify-between items-center">
  //   //     <div className=" ">
  //   //       <h2 className="text-xl font-medium text-[#212121]  ">
  //   //         Order Summary
  //   //       </h2>
  //   //     </div>
  //   //     <div className="flex gap-2">
  //   //       <div className="relative inline-block text-left" ref={dropdownRef}>
  //   //         <button
  //   //           onClick={() => setOpen(!open)}
  //   //           className="flex items-center rounded-full border-[0.5px] border-[#D2D2D2] px-4 py-2.5 text-sm bg-white text-black  space-x-2"
  //   //         >
  //   //           <span>{selected}</span>
  //   //           <IconChevronDown size={18} />
  //   //         </button>

  //   //         {open && (
  //   //           <div className="absolute right-0 mt-2 w-40 bg-white border rounded-md shadow-lg z-50">
  //   //             {options.map((option) => (
  //   //               <div
  //   //                 key={option}
  //   //                 onClick={() => {
  //   //                   setSelected(option);
  //   //                   setOpen(false);
  //   //                 }}
  //   //                 className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
  //   //               >
  //   //                 {option}
  //   //               </div>
  //   //             ))}
  //   //           </div>
  //   //         )}
  //   //       </div>
  //   //     </div>
  //   //   </div>
  //   //   <div className="mx-4 lg:mx-0 col-span-12 lg:col-span-7">
  //   //     <div className="grid grid-cols-4 gap-10">
  //   //       {metrics.map((metric, idx) => (
  //   //         <div key={idx} className="">
  //   //           <div className="flex items-end space-x-2">
  //   //             <div className="text-gray-600 bg-[#585858]/10 rounded-lg p-1.5">
  //   //               {typeof metric.icon === "string" ? (
  //   //                 <img
  //   //                   src={metric.icon}
  //   //                   alt={metric.label}
  //   //                   className="2xl:size-7 size-6 "
  //   //                 />
  //   //               ) : (
  //   //                 metric.icon
  //   //               )}
  //   //             </div>
  //   //             <div className="2xl:text-5xl text-4xl font-light text-[#212121]">
  //   //               {metric.value}
  //   //             </div>
  //   //           </div>
  //   //           <div className="text-sm text-[#212121]/70">{metric.label}</div>
  //   //         </div>
  //   //       ))}
  //   //     </div>
  //   //   </div>

  //   //   <div className="col-span-12 lg:col-span-5">
  //   //     <div className="bg-[#303030] rounded-3xl p-8 py-4 text-white flex flex-row items-center 2xl:space-x-20 space-x-6">
  //   //       <div className="2xl:size-60 size-48   relative flex items-center justify-center">
  //   //         <PieChart
  //   //           width={250}
  //   //           height={250}
  //   //           className="relative w-full h-full"
  //   //         >
  //   //           <Pie
  //   //             data={donutData}
  //   //             dataKey="value"
  //   //             cx="50%"
  //   //             cy="50%"
  //   //             innerRadius={100}
  //   //             outerRadius={120}
  //   //             strokeWidth={0}
  //   //             fill="#8884d8"
  //   //             paddingAngle={0}

  //   //           >
  //   //             {donutData.map((entry, index) => (
  //   //               <Cell key={`cell-${index}`} fill={entry.color} />
  //   //             ))}
  //   //           </Pie>

  //   //           <foreignObject x="85" y="85" width="80" height="80">
  //   //             <div className="flex flex-col items-center justify-center h-full w-full text-white text-center">
  //   //               <div className="text-xs">Total Orders</div>
  //   //               <div className="text-2xl font-semibold">{data?.total}</div>
  //   //             </div>
  //   //           </foreignObject>
  //   //         </PieChart>
  //   //       </div>

  //   //       <div className="w-full space-y-0 text-sm">
  //   //         {donutData?.map((item, idx) => (
  //   //           <div key={idx} className="flex justify-between items-center">
  //   //             <div className="flex items-center gap-2">
  //   //               <span
  //   //                 className="inline-block w-2.5 h-2.5 rounded-full"
  //   //                 style={{ backgroundColor: item?.color }}
  //   //               ></span>
  //   //               <span>{item?.name}</span>
  //   //             </div>
  //   //             <p className="text-base font-medium">
  //   //               {item?.value?.toLocaleString()}
  //   //             </p>
  //   //           </div>
  //   //         ))}
  //   //       </div>
  //   //     </div>
  //   //   </div>
  //   // </div>

  //   <div className="space-y-6">
  //     <div className=" flex justify-between items-center">
  //       <div className=" ">
  //         <h2 className="text-xl font-medium text-[#212121]  ">
  //           Order Summary
  //         </h2>
  //       </div>
  //     </div>
  //     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8 gap-y-4 sm:gap-y-5 gap-x-3">
  //       {metrics.map((metric, idx) => {
  //         const lmPercent =
  //           metric.total > 0
  //             ? Math.round((metric.lm / metric.total) * 100)
  //             : 100;

  //         return (
  //           <div
  //             key={idx}
  //             className="bg-white/20 rounded-2xl shadow-lg border border-[#D2D2D2] p-2"
  //           >
  //             {/* Top */}
  //             <div className="flex justify-between text-xs font-semibold text-gray-900 mb-2">
  //               <span>LM {metric.lm ?? 0}</span>
  //               <span className="text-[#ff6600]">FM {metric.fm ?? 0}</span>
  //             </div>

  //             {/* Progress Bar */}
  //             <div className="w-full h-2 rounded-full bg-gray-100 overflow-hidden mb-4">
  //               <div
  //                 className="h-full rounded-full"
  //                 style={{
  //                   width: "100%",
  //                   background:
  //                     showLM && showFM
  //                       ? `linear-gradient(
  //                   90deg,
  //                   #FACC15 0%,
  //                   #FACC15 ${lmPercent}%,
  //                   #22C55E ${lmPercent}%,
  //                   #22C55E 100%
  //                 )`
  //                       : showLM
  //                         ? "#FACC15"
  //                         : "#22C55E",
  //                 }}
  //               />
  //             </div>

  //             {/* Bottom */}
  //             <div className="flex items-center gap-3">
  //               <div className="w-12 h-12 bg-[#818181]/10 rounded-[10px] flex items-center justify-center">
  //                 <img
  //                   src={metric.icon}
  //                   alt={metric.label}
  //                   className="size-6"
  //                 />
  //               </div>

  //               <div className="text-sm font-medium text-gray-700">
  //                 {metric.label}
  //                 <span className="font-semibold text-gray-900">
  //                   {" "}
  //                   {metric.total}
  //                 </span>
  //               </div>
  //             </div>
  //           </div>
  //         );
  //       })}
  //     </div>
  //   </div>
  // );
}
